import { useEffect, useRef, useState } from "react";

// Returns a ref + a translateY/scale value that updates on scroll.
// Place ref on the moving element. Defaults give a slow, cinematic drift.
export default function useParallax({ speed = 0.18, max = 80 } = {}) {
  const ref = useRef(null);
  const [y, setY] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight || 1;
        // distance from element centre to viewport centre, normalised -1..1
        const center = rect.top + rect.height / 2;
        const offset = (center - vh / 2) / vh;
        const next = Math.max(-max, Math.min(max, -offset * speed * vh));
        setY(next);
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [speed, max]);

  return [ref, y];
}
